import { Alert, Box, Stack, useMediaQuery, useTheme, Container } from "@mui/material";
import HeaderWithBackNav from './ui-header-back';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/store';

type LobbyErrorProps = {
    message: string | number;
};

export default function LobbyError({message} : LobbyErrorProps) {
    const theme = useTheme();
    const desktopView = useMediaQuery(theme.breakpoints.up("sm"));
    const errors = useSelector((state:RootState) => state.ui.language.errors);
    
    let msg = message;
    
    if(typeof message === 'number')
    {
        msg = errors[message];
    }
    
    return(
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} width={"100%"} minHeight={"100dvh"}>
            <Container maxWidth="xl">
                <center>
                    <Box bgcolor={desktopView ? theme.palette.secondary.main : ""} borderRadius={1} padding={2} width={desktopView ? "60%" : "100%"}>
                        <HeaderWithBackNav text="Lobby error" size={"md"} target="/join" />
                        <Stack gap={2}>
                                <Alert severity="error">{msg}</Alert>
                        </Stack>
                    </Box>
                </center>
            </Container>
        </Box>
    );
}
